<template>
  <footer class="global-footer-container">
    <copyright-notification />
    <page-top-scroll
      :top-scroll-element-id="topScrollElementId"
    />
    <sns-account-link />
    <copyright />
  </footer>
</template>

<script>
import CopyrightNotification from './global-footer/copyright-notification';
import PageTopScroll         from './global-footer/page-top-scroll';
import SnsAccountLink        from './global-footer/sns-account-link';
import Copyright             from './global-footer/copyright';

export default {
  name      : 'global-footer',
  components: {
    CopyrightNotification,
    PageTopScroll,
    SnsAccountLink,
    Copyright,
  },
  props: {
    topScrollElementId: {
      type   : String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@charset "utf-8";

// import
@import "~@istyle-inc/global-navigation/sass/sp/global_footer";
</style>
